import { WebFormSettingsAction } from './webform.actions';
import { WebFormSettingsTypes } from './webform.types';
import { WebFormSettingsState } from './webform.state';

const webFormSettingsReducer = (
    state: WebFormSettingsState = {},
    action: WebFormSettingsAction
) => {
    switch (action.type) {
        case WebFormSettingsTypes.SET_WEBFORM_CONFIGS:
            return {
                ...state,
                [action.payload.brand]: {
                    webformConfigs: action.payload.webformConfigs,
                    isLoading: false,
                },
            };

        case WebFormSettingsTypes.SET_WEBFORM_CONFIGS_LOADING:
            return {
                ...state,
                [action.payload.brand]: {
                    ...state[action.payload.brand],
                    isLoading: action.payload.isLoading,
                },
            };

        default:
            return state;
    }
};

export default webFormSettingsReducer;
